import React, { useEffect, useState } from "react";
import {
  getSkillList,
  getDistrictList,
  getStateList,
  getCommunities,
} from "../../../CrudOperations/GetOperation";

const CheckPointForm = ({
  formData,
  setFormData,
  submitForm,
  onSuccess,
  editCheckpoint,
}) => {
  const [SkillsList, setSkillsList] = useState([]);
  const [DistrictList, setDistrictList] = useState([]);
  const [StateList, setStateList] = useState([]);
  const [CommunityList, setCommunityList] = useState([]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      const [skillRes, districtRes, stateRes, communityRes] = await Promise.all([
        getSkillList(),
        getDistrictList(),
        getStateList(),
        getCommunities(),
      ]);

      if (skillRes?.data?.Message === "Success") {
        setSkillsList(skillRes.data.Data);
      }
      if (districtRes?.data) {
        setDistrictList(districtRes.data);
      }
      if (stateRes?.data) {
        setStateList(stateRes.data);
      }
      if (communityRes?.data?.length > 0) {
        setCommunityList(communityRes.data);
      }
    };

    fetchDropdowns();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSkillChange = (index, value) => {
    const updatedSkills = [...formData.CheckpointSkills];
    updatedSkills[index] = { SkillId: parseInt(value) };
    setFormData({ ...formData, CheckpointSkills: updatedSkills });
  };

  const handleNoOfSkills = (e) => {
    const count = parseInt(e.target.value) || 0;
    const currentSkills = [...formData.CheckpointSkills];
    while (currentSkills.length < count) currentSkills.push({ SkillId: "" });
    currentSkills.length = count;
    setFormData({ ...formData, CheckpointSkills: currentSkills });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitForm();
    onSuccess();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 text-sm mt-3 text-gray-800 max-h-[70vh] overflow-y-auto pr-2"
    >
      {/* Text Inputs */}
      {[
        { label: "Checkpoint Name", name: "DeputyCheckpointName", type: "text" },
        { label: "Pincode", name: "Pincode", type: "number" },
        { label: "Landmark", name: "LandMark", type: "text" },
        { label: "Start Date", name: "StartDate", type: "date" },
        { label: "End Date", name: "EndDate", type: "date" },
        { label: "Start Time", name: "StartTime", type: "time" },
        { label: "End Time", name: "EndTime", type: "time" },
      ].map((field) => (
        <div key={field.name}>
          <label className="block font-medium mb-1">{field.label}</label>
          <input
            type={field.type}
            name={field.name}
            value={formData[field.name] || ""}
            onChange={handleChange}
            required={field.name !== "EndDate" && field.name !== "EndTime"}
            className="w-full border px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      ))}

      {/* Gender */}
      <div>
        <label className="block font-medium mb-1">Gender</label>
        <select
          name="Gender"
          value={formData.Gender || ""}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded-md"
          required
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>

      {/* Community */}
      <div>
        <label className="block font-medium mb-1">Community</label>
        <select
          name="CommunityId"
          value={formData.CommunityId || ""}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded-md"
          required
        >
          <option value="">Select Community</option>
          {CommunityList.map((c) => (
            <option key={c.CommunityId} value={c.CommunityId}>
              {c.CommunityName}
            </option>
          ))}
        </select>
      </div>

      {/* District */}
      <div>
        <label className="block font-medium mb-1">District</label>
        <select
          name="DistrictId"
          value={formData.DistrictId || ""}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded-md"
          required
        >
          <option value="">Select District</option>
          {DistrictList.map((d) => (
            <option key={d.DistrictId} value={d.DistrictId}>
              {d.DistrictName}
            </option>
          ))}
        </select>
      </div>

      {/* State */}
      <div>
        <label className="block font-medium mb-1">State</label>
        <select
          name="StateId"
          value={formData.StateId || ""}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded-md"
          required
        >
          <option value="">Select State</option>
          {StateList.map((s) => (
            <option key={s.StateId} value={s.StateId}>
              {s.StateName}
            </option>
          ))}
        </select>
      </div>

      {/* Skills */}
      <div>
        <label className="block font-medium mb-1">Number of Skills</label>
        <input
          type="number"
          value={formData.CheckpointSkills?.length || 0}
          onChange={handleNoOfSkills}
          className="w-full border px-3 py-2 rounded-md"
        />
      </div>

      {formData.CheckpointSkills?.map((skill, index) => (
        <div key={index}>
          <label className="block font-medium mb-1">Skill {index + 1}</label>
          <select
            value={skill.SkillId || ""}
            onChange={(e) => handleSkillChange(index, e.target.value)}
            className="w-full border px-3 py-2 rounded-md"
            required
          >
            <option value="">Select Skill</option>
            {SkillsList.map((s) => (
              <option key={s.SkillId} value={s.SkillId}>
                {s.SkillName}
              </option>
            ))}
          </select>
        </div>
      ))}

      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 mt-4 transition"
      >
        {editCheckpoint ? "Update Checkpoint" : "Add Checkpoint"}
      </button>
    </form>
  );
};

export default CheckPointForm;
